import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

const AUTO_RETURN_SECONDS = 5;

export default function SuccessPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [params] = useSearchParams();
  const state = location.state ?? {};
  const [secondsLeft, setSecondsLeft] = useState(AUTO_RETURN_SECONDS);

  // Preserve org/site/checkoutId so we return to the Camera Checkout
  // (2-options) screen with the same tenant context we started with.
  const returnUrl = (() => {
    const qp = new URLSearchParams();
    const keys = ['checkoutId', 'org', 'site', 'orgId', 'siteId'];
    for (const k of keys) {
      const v = params.get(k);
      if (v) qp.set(k, v);
    }
    const s = qp.toString();
    return `/checkout/camera${s ? `?${s}` : ''}`;
  })();

  useEffect(() => {
    if (secondsLeft <= 0) {
      navigate(returnUrl, { replace: true });
      return;
    }
    const t = setTimeout(() => setSecondsLeft((s) => s - 1), 1000);
    return () => clearTimeout(t);
  }, [secondsLeft, navigate, returnUrl]);

  const done = () => navigate(returnUrl, { replace: true });

  return (
    <div className="ck-page ck-success">
      <button
        type="button"
        aria-label="Close"
        onClick={done}
        className="ck-success-close"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </button>

      <div className="ck-success-inner">
        <div className="ck-success-badge">
          <div className="ck-success-badge-inner">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M5 12l5 5 9-11" stroke="#0A1428" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
        </div>

        <h1 className="ck-success-heading">You&rsquo;re all set. Have a great shift!</h1>
        {(state.name || state.employeeId) && (
          <p className="ck-success-name">
            {state.name}
            {state.employeeId ? ` (#${state.employeeId})` : ''}
          </p>
        )}

        <button type="button" onClick={done} className="ck-submit ck-success-done">
          Done
        </button>
        <p className="ck-success-countdown">
          Returning to home page in <span className="ck-success-countdown-n">{secondsLeft}</span> seconds
        </p>
      </div>
    </div>
  );
}

